module.exports = __webpack_public_path__ + "img/ma.133b5845.png";